export const REGISTRATION_URL = 'https://zynixx-player.tradex.live/register?platform=zynixx';
export const DEPOSIT_URL = 'https://dev-player.tradex.live/quick-deposit?platform=zynixx';